import {
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  VOID3gxj6tk5isa35 as VOID,
  Unit_instance1fbcbse1fwigr as Unit_instance,
  objectCreate1ve4bgxiu4x98 as objectCreate,
  isFinite2t9l5a275mxm6 as isFinite,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  equals2au1ep9vhcato as equals,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  toString1pkumu07cwy4m as toString,
  IllegalArgumentException_init_$Create$3ewkh27kzt8z8 as IllegalArgumentException_init_$Create$,
  coerceIn1xblvmyr0tby6 as coerceIn,
  Collection1k04j3hzsbod0 as Collection,
  isInterface3d6p8outrmvmk as isInterface,
  emptyList1g2z5xcrvp2zy as emptyList,
  ArrayList_init_$Create$149jv2ovkkvnt as ArrayList_init_$Create$,
  sum2ku6kbgxq0lee as sum,
  first58ocm7j58k3q as first,
  get_lastIndex1yw0x4k50k51w as get_lastIndex,
  coerceIn10f36k81le1mm as coerceIn_0,
  coerceAtLeastklytehohcpeq as coerceAtLeast,
  last1vo29oleiqj36 as last,
  isBlank1dvkhjjvox3p0 as isBlank,
  KtList3hktaavzmj137 as KtList,
  getKClass3t8tygqu4lcxf as getKClass,
  PrimitiveClasses_getInstance2v63zn04dtq03 as PrimitiveClasses_getInstance,
  arrayOf1akklvh2at202 as arrayOf,
  createKType31ecntyyaay3k as createKType,
  createInvariantKTypeProjection3h5364czc0a8w as createInvariantKTypeProjection,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  ArrayList_init_$Create$3bxttkj3v1mea as ArrayList_init_$Create$_0,
} from './kotlin-kotlin-stdlib.mjs';
import {
  PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor,
  UnknownFieldException_init_$Create$hprktcyan42n as UnknownFieldException_init_$Create$,
  DoubleSerializer_getInstance3da4hv5ndgjlx as DoubleSerializer_getInstance,
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException,
  IntSerializer_getInstance2q7s8kvk1il5u as IntSerializer_getInstance,
  BooleanSerializer_getInstance1t8habeqgiyq1 as BooleanSerializer_getInstance,
  serializer1i4e9ym37oxmo as serializer,
  KSerializerzf77vz1967fq as KSerializer,
} from './kotlinx-serialization-kotlinx-serialization-core.mjs';
import { Default_getInstance363hicrc7jsft as Default_getInstance } from './kotlinx-serialization-kotlinx-serialization-json.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
initMetadataForCompanion(Companion);
initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(LatLng, 'LatLng', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
initMetadataForCompanion(Companion_0);
initMetadataForObject($serializer_0, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RouteProgress, 'RouteProgress', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
initMetadataForObject(NavigationEngine, 'NavigationEngine');
//endregion
function Companion() {
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
function $serializer() {
  $serializer_instance = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('il.derech.shared.LatLng', this, 2);
  tmp0_serialDesc.jp('lat', false);
  tmp0_serialDesc.jp('lng', false);
  this.h18_1 = tmp0_serialDesc;
}
protoOf($serializer).i18 = function (encoder, value) {
  var tmp0_desc = this.h18_1;
  var tmp1_output = encoder.gi(tmp0_desc);
  tmp1_output.rj(tmp0_desc, 0, value.j18_1);
  tmp1_output.rj(tmp0_desc, 1, value.k18_1);
  tmp1_output.hi(tmp0_desc);
};
protoOf($serializer).kf = function (encoder, value) {
  return this.i18(encoder, value instanceof LatLng ? value : THROW_CCE());
};
protoOf($serializer).lf = function (decoder) {
  var tmp0_desc = this.h18_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = 0.0;
  var tmp5_local1 = 0.0;
  var tmp6_input = decoder.gi(tmp0_desc);
  if (tmp6_input.vi()) {
    tmp4_local0 = tmp6_input.oi(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.oi(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.wi(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.oi(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.oi(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.hi(tmp0_desc);
  return LatLng_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer).jf = function () {
  return this.h18_1;
};
protoOf($serializer).lp = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [DoubleSerializer_getInstance(), DoubleSerializer_getInstance()];
};
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance == null)
    new $serializer();
  return $serializer_instance;
}
function LatLng_init_$Init$(seen0, lat, lng, serializationConstructorMarker, $this) {
  if (!(3 === (3 & seen0))) {
    throwMissingFieldException(seen0, 3, $serializer_getInstance().h18_1);
  }
  $this.j18_1 = lat;
  $this.k18_1 = lng;
  return $this;
}
function LatLng_init_$Create$(seen0, lat, lng, serializationConstructorMarker) {
  return LatLng_init_$Init$(seen0, lat, lng, serializationConstructorMarker, objectCreate(protoOf(LatLng)));
}
function LatLng(lat, lng) {
  this.j18_1 = lat;
  this.k18_1 = lng;
}
protoOf(LatLng).l18 = function () {
  var tmp;
  var tmp_0;
  if (isFinite(this.j18_1) && isFinite(this.k18_1)) {
    var containsLower = -90.0;
    var containsArg = this.j18_1;
    tmp_0 = containsLower <= containsArg ? containsArg <= 90.0 : false;
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    var containsLower_0 = -180.0;
    var containsArg_0 = this.k18_1;
    tmp = containsLower_0 <= containsArg_0 ? containsArg_0 <= 180.0 : false;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(LatLng).toString = function () {
  return 'LatLng(lat=' + this.j18_1 + ', lng=' + this.k18_1 + ')';
};
protoOf(LatLng).hashCode = function () {
  var result = getNumberHashCode(this.j18_1);
  result = imul(result, 31) + getNumberHashCode(this.k18_1) | 0;
  return result;
};
protoOf(LatLng).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof LatLng))
    return false;
  if (!equals(this.j18_1, other.j18_1))
    return false;
  if (!equals(this.k18_1, other.k18_1))
    return false;
  return true;
};
function Companion_0() {
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
function $serializer_0() {
  $serializer_instance_0 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('il.derech.shared.RouteProgress', this, 7);
  tmp0_serialDesc.jp('snapped', false);
  tmp0_serialDesc.jp('traveledMeters', false);
  tmp0_serialDesc.jp('remainingMeters', false);
  tmp0_serialDesc.jp('distanceFromRoute', false);
  tmp0_serialDesc.jp('segmentIndex', false);
  tmp0_serialDesc.jp('offRoute', false);
  tmp0_serialDesc.jp('arrived', false);
  this.m18_1 = tmp0_serialDesc;
}
protoOf($serializer_0).n18 = function (encoder, value) {
  var tmp0_desc = this.m18_1;
  var tmp1_output = encoder.gi(tmp0_desc);
  tmp1_output.vj(tmp0_desc, 0, $serializer_getInstance(), value.o18_1);
  tmp1_output.rj(tmp0_desc, 1, value.p18_1);
  tmp1_output.rj(tmp0_desc, 2, value.q18_1);
  tmp1_output.rj(tmp0_desc, 3, value.r18_1);
  tmp1_output.oj(tmp0_desc, 4, value.s18_1);
  tmp1_output.lj(tmp0_desc, 5, value.t18_1);
  tmp1_output.lj(tmp0_desc, 6, value.u18_1);
  tmp1_output.hi(tmp0_desc);
};
protoOf($serializer_0).kf = function (encoder, value) {
  return this.n18(encoder, value instanceof RouteProgress ? value : THROW_CCE());
};
protoOf($serializer_0).lf = function (decoder) {
  var tmp0_desc = this.m18_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = 0.0;
  var tmp6_local2 = 0.0;
  var tmp7_local3 = 0.0;
  var tmp8_local4 = 0;
  var tmp9_local5 = false;
  var tmp10_local6 = false;
  var tmp11_input = decoder.gi(tmp0_desc);
  if (tmp11_input.vi()) {
    tmp4_local0 = tmp11_input.si(tmp0_desc, 0, $serializer_getInstance(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp11_input.oi(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp11_input.oi(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp11_input.oi(tmp0_desc, 3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp11_input.li(tmp0_desc, 4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
    tmp9_local5 = tmp11_input.ii(tmp0_desc, 5);
    tmp3_bitMask0 = tmp3_bitMask0 | 32;
    tmp10_local6 = tmp11_input.ii(tmp0_desc, 6);
    tmp3_bitMask0 = tmp3_bitMask0 | 64;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp11_input.wi(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp11_input.si(tmp0_desc, 0, $serializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp11_input.oi(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp11_input.oi(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp11_input.oi(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp11_input.li(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        case 5:
          tmp9_local5 = tmp11_input.ii(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          break;
        case 6:
          tmp10_local6 = tmp11_input.ii(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp11_input.hi(tmp0_desc);
  return RouteProgress_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
};
protoOf($serializer_0).jf = function () {
  return this.m18_1;
};
protoOf($serializer_0).lp = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), IntSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance()];
};
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 == null)
    new $serializer_0();
  return $serializer_instance_0;
}
function RouteProgress_init_$Init$(seen0, snapped, traveledMeters, remainingMeters, distanceFromRoute, segmentIndex, offRoute, arrived, serializationConstructorMarker, $this) {
  if (!(127 === (127 & seen0))) {
    throwMissingFieldException(seen0, 127, $serializer_getInstance_0().m18_1);
  }
  $this.o18_1 = snapped;
  $this.p18_1 = traveledMeters;
  $this.q18_1 = remainingMeters;
  $this.r18_1 = distanceFromRoute;
  $this.s18_1 = segmentIndex;
  $this.t18_1 = offRoute;
  $this.u18_1 = arrived;
  return $this;
}
function RouteProgress_init_$Create$(seen0, snapped, traveledMeters, remainingMeters, distanceFromRoute, segmentIndex, offRoute, arrived, serializationConstructorMarker) {
  return RouteProgress_init_$Init$(seen0, snapped, traveledMeters, remainingMeters, distanceFromRoute, segmentIndex, offRoute, arrived, serializationConstructorMarker, objectCreate(protoOf(RouteProgress)));
}
function RouteProgress(snapped, traveledMeters, remainingMeters, distanceFromRoute, segmentIndex, offRoute, arrived) {
  this.o18_1 = snapped;
  this.p18_1 = traveledMeters;
  this.q18_1 = remainingMeters;
  this.r18_1 = distanceFromRoute;
  this.s18_1 = segmentIndex;
  this.t18_1 = offRoute;
  this.u18_1 = arrived;
}
protoOf(RouteProgress).toString = function () {
  return 'RouteProgress(snapped=' + this.o18_1.toString() + ', traveledMeters=' + this.p18_1 + ', remainingMeters=' + this.q18_1 + ', distanceFromRoute=' + this.r18_1 + ', segmentIndex=' + this.s18_1 + ', offRoute=' + this.t18_1 + ', arrived=' + this.u18_1 + ')';
};
protoOf(RouteProgress).hashCode = function () {
  var result = this.o18_1.hashCode();
  result = imul(result, 31) + getNumberHashCode(this.p18_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.q18_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.r18_1) | 0;
  result = imul(result, 31) + this.s18_1 | 0;
  result = imul(result, 31) + getBooleanHashCode(this.t18_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.u18_1) | 0;
  return result;
};
protoOf(RouteProgress).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof RouteProgress))
    return false;
  if (!this.o18_1.equals(other.o18_1))
    return false;
  if (!equals(this.p18_1, other.p18_1))
    return false;
  if (!equals(this.q18_1, other.q18_1))
    return false;
  if (!equals(this.r18_1, other.r18_1))
    return false;
  if (!(this.s18_1 === other.s18_1))
    return false;
  if (!(this.t18_1 === other.t18_1))
    return false;
  if (!(this.u18_1 === other.u18_1))
    return false;
  return true;
};
function radians(degrees) {
  return degrees * 3.141592653589793 / 180.0;
}
function longitudeDelta(degrees) {
  return (degrees + 540.0) % 360.0 - 180.0;
}
function haversineMeters(from, to) {
  // Inline function 'kotlin.require' call
  if (!(from.l18() && to.l18())) {
    var message = 'Invalid coordinates';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.math.sin' call
  var x = radians(to.j18_1 - from.j18_1) / 2;
  // Inline function 'kotlin.math.pow' call
  var this_0 = Math.sin(x);
  var tmp = Math.pow(this_0, 2);
  // Inline function 'kotlin.math.cos' call
  var x_0 = radians(from.j18_1);
  var tmp_0 = Math.cos(x_0);
  // Inline function 'kotlin.math.cos' call
  var x_1 = radians(to.j18_1);
  var tmp_1 = tmp_0 * Math.cos(x_1);
  // Inline function 'kotlin.math.sin' call
  var x_2 = radians(longitudeDelta(to.k18_1 - from.k18_1)) / 2;
  // Inline function 'kotlin.math.pow' call
  var this_1 = Math.sin(x_2);
  var a = tmp + tmp_1 * Math.pow(this_1, 2);
  var tmp_2 = 2.0 * 6371008.8;
  // Inline function 'kotlin.math.sqrt' call
  var x_3 = coerceIn(a, 0.0, 1.0);
  // Inline function 'kotlin.math.asin' call
  var x_4 = Math.sqrt(x_3);
  return tmp_2 * Math.asin(x_4);
}
function NavigationEngine() {
}
protoOf(NavigationEngine).v18 = function (position, geometry, minimumSegment, offRouteThreshold, arrivalRadius) {
  var tmp;
  var tmp_0;
  if (position.l18()) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    tmp_0 = !geometry.l();
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp_1;
      if (isInterface(geometry, Collection)) {
        tmp_1 = geometry.l();
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp$ret$1 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = geometry.h();
      while (_iterator__ex2g4s.i()) {
        var element = _iterator__ex2g4s.j();
        if (!element.l18()) {
          tmp$ret$1 = false;
          break $l$block_0;
        }
      }
      tmp$ret$1 = true;
    }
    tmp = tmp$ret$1;
  } else {
    tmp = false;
  }
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.require' call
  if (!tmp) {
    var message = 'Failed requirement.';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  if (geometry.k() === 1) {
    var distance = haversineMeters(position, geometry.m(0));
    return new RouteProgress(geometry.m(0), 0.0, 0.0, distance, 0, distance > offRouteThreshold, distance <= arrivalRadius);
  }
  var tmp$ret$6;
  $l$block_1: {
    // Inline function 'kotlin.collections.zipWithNext' call
    var iterator = geometry.h();
    if (!iterator.i()) {
      tmp$ret$6 = emptyList();
      break $l$block_1;
    }
    // Inline function 'kotlin.collections.mutableListOf' call
    var result = ArrayList_init_$Create$();
    var current = iterator.j();
    while (iterator.i()) {
      var next = iterator.j();
      var a = current;
      var tmp$ret$8 = haversineMeters(a, next);
      result.f(tmp$ret$8);
      current = next;
    }
    tmp$ret$6 = result;
  }
  var lengths = tmp$ret$6;
  var total = sum(lengths);
  var cumulative = 0.0;
  var bestDistance = Infinity;
  var bestTraveled = 0.0;
  var bestPoint = first(geometry);
  var bestSegment = 0;
  var start = coerceIn_0(minimumSegment, 0, get_lastIndex(geometry) - 1 | 0);
  var inductionVariable = 0;
  var last_0 = lengths.k() - 1 | 0;
  if (inductionVariable <= last_0)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var a_0 = geometry.m(index);
      var b = geometry.m(index + 1 | 0);
      if (index >= start) {
        // Inline function 'kotlin.math.cos' call
        var x = radians((a_0.j18_1 + b.j18_1) / 2);
        var tmp$ret$9 = Math.cos(x);
        var cosLat = coerceAtLeast(tmp$ret$9, 1.0E-6);
        var bx = radians(longitudeDelta(b.k18_1 - a_0.k18_1)) * 6371008.8 * cosLat;
        var by = radians(b.j18_1 - a_0.j18_1) * 6371008.8;
        var px = radians(longitudeDelta(position.k18_1 - a_0.k18_1)) * 6371008.8 * cosLat;
        var py = radians(position.j18_1 - a_0.j18_1) * 6371008.8;
        var denominator = bx * bx + by * by;
        var fraction = denominator <= 0.0 ? 0.0 : coerceIn((px * bx + py * by) / denominator, 0.0, 1.0);
        var point = new LatLng(a_0.j18_1 + (b.j18_1 - a_0.j18_1) * fraction, longitudeDelta(a_0.k18_1 + longitudeDelta(b.k18_1 - a_0.k18_1) * fraction));
        var distance_0 = haversineMeters(position, point);
        if (distance_0 < bestDistance) {
          bestDistance = distance_0;
          bestTraveled = cumulative + lengths.m(index) * fraction;
          bestPoint = point;
          bestSegment = index;
        }
      }
      cumulative = cumulative + lengths.m(index);
    }
     while (inductionVariable <= last_0);
  var remaining = coerceAtLeast(total - bestTraveled, 0.0);
  return new RouteProgress(bestPoint, bestTraveled, remaining, bestDistance, bestSegment, bestDistance > offRouteThreshold, remaining <= arrivalRadius && haversineMeters(position, last(geometry)) <= arrivalRadius);
};
protoOf(NavigationEngine).w18 = function (position, geometry, minimumSegment, offRouteThreshold, arrivalRadius, $super) {
  minimumSegment = minimumSegment === VOID ? 0 : minimumSegment;
  offRouteThreshold = offRouteThreshold === VOID ? 65.0 : offRouteThreshold;
  arrivalRadius = arrivalRadius === VOID ? 25.0 : arrivalRadius;
  return $super === VOID ? this.v18(position, geometry, minimumSegment, offRouteThreshold, arrivalRadius) : $super.v18.call(this, position, geometry, minimumSegment, offRouteThreshold, arrivalRadius);
};
var NavigationEngine_instance;
function NavigationEngine_getInstance() {
  return NavigationEngine_instance;
}
function hebrewInstruction(type, modifier, roadName, exit) {
  modifier = modifier === VOID ? '' : modifier;
  roadName = roadName === VOID ? '' : roadName;
  exit = exit === VOID ? null : exit;
  var tmp;
  switch (type) {
    case 'depart':
      tmp = '\u05D9\u05D5\u05E6\u05D0\u05D9\u05DD \u05DC\u05D3\u05E8\u05DA';
      break;
    case 'arrive':
      tmp = '\u05D4\u05D2\u05E2\u05EA \u05DC\u05D9\u05E2\u05D3';
      break;
    case 'roundabout':
    case 'rotary':
    case 'roundabout turn':
      tmp = !(exit == null) ? '\u05D1\u05DB\u05D9\u05DB\u05E8, \u05E6\u05D0\u05D5 \u05D1\u05D9\u05E6\u05D9\u05D0\u05D4 \u05D4\u05BE' + exit : '\u05D4\u05D9\u05DB\u05E0\u05E1\u05D5 \u05DC\u05DB\u05D9\u05DB\u05E8';
      break;
    case 'exit roundabout':
    case 'exit rotary':
      tmp = '\u05E6\u05D0\u05D5 \u05DE\u05D4\u05DB\u05D9\u05DB\u05E8';
      break;
    case 'merge':
      tmp = '\u05D4\u05E9\u05EA\u05DC\u05D1\u05D5 \u05D1\u05EA\u05E0\u05D5\u05E2\u05D4';
      break;
    case 'on ramp':
      tmp = '\u05E2\u05DC\u05D5 \u05DC\u05DE\u05D7\u05DC\u05E3';
      break;
    case 'off ramp':
      tmp = '\u05E6\u05D0\u05D5 \u05D1\u05DE\u05D7\u05DC\u05E3';
      break;
    case 'fork':
      switch (modifier) {
        case 'left':
        case 'slight left':
          tmp = '\u05D4\u05D9\u05E6\u05DE\u05D3\u05D5 \u05DC\u05E9\u05DE\u05D0\u05DC';
          break;
        case 'right':
        case 'slight right':
          tmp = '\u05D4\u05D9\u05E6\u05DE\u05D3\u05D5 \u05DC\u05D9\u05DE\u05D9\u05DF';
          break;
        default:
          tmp = '\u05D4\u05DE\u05E9\u05D9\u05DB\u05D5 \u05D9\u05E9\u05E8';
          break;
      }

      break;
    default:
      switch (modifier) {
        case 'uturn':
          tmp = '\u05D1\u05E6\u05E2\u05D5 \u05E4\u05E0\u05D9\u05D9\u05EA \u05E4\u05E8\u05E1\u05D4';
          break;
        case 'left':
          tmp = '\u05E4\u05E0\u05D5 \u05E9\u05DE\u05D0\u05DC\u05D4';
          break;
        case 'right':
          tmp = '\u05E4\u05E0\u05D5 \u05D9\u05DE\u05D9\u05E0\u05D4';
          break;
        case 'slight left':
          tmp = '\u05E4\u05E0\u05D5 \u05E7\u05DC\u05D5\u05EA \u05E9\u05DE\u05D0\u05DC\u05D4';
          break;
        case 'slight right':
          tmp = '\u05E4\u05E0\u05D5 \u05E7\u05DC\u05D5\u05EA \u05D9\u05DE\u05D9\u05E0\u05D4';
          break;
        case 'sharp left':
          tmp = '\u05E4\u05E0\u05D5 \u05D1\u05D7\u05D3\u05D5\u05EA \u05E9\u05DE\u05D0\u05DC\u05D4';
          break;
        case 'sharp right':
          tmp = '\u05E4\u05E0\u05D5 \u05D1\u05D7\u05D3\u05D5\u05EA \u05D9\u05DE\u05D9\u05E0\u05D4';
          break;
        default:
          tmp = '\u05D4\u05DE\u05E9\u05D9\u05DB\u05D5 \u05D9\u05E9\u05E8';
          break;
      }

      break;
  }
  var action = tmp;
  return isBlank(roadName) || type === 'arrive' ? action : action + ' \u05D0\u05DC ' + roadName;
}
function distanceMeters(fromLat, fromLng, toLat, toLng) {
  return haversineMeters(new LatLng(fromLat, fromLng), new LatLng(toLat, toLng));
}
function instructionHebrew(type, modifier, roadName) {
  return hebrewInstruction(type, modifier, roadName);
}
function routeProgressJson(lat, lng, coordinatesJson, minimumSegment) {
  // Inline function 'kotlinx.serialization.json.Json.decodeFromString' call
  var this_0 = Default_getInstance();
  // Inline function 'kotlinx.serialization.serializer' call
  var this_1 = this_0.ui();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_2 = serializer(this_1, createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().u8(), arrayOf([]), false))]), false))]), false));
  var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
  // Inline function 'kotlin.collections.map' call
  var this_3 = this_0.cy(tmp$ret$1, coordinatesJson);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_3, 10));
  var _iterator__ex2g4s = this_3.h();
  while (_iterator__ex2g4s.i()) {
    var item = _iterator__ex2g4s.j();
    // Inline function 'kotlin.require' call
    if (!(item.k() >= 2)) {
      var message = 'Invalid coordinate';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    var tmp$ret$5 = new LatLng(item.m(1), item.m(0));
    destination.f(tmp$ret$5);
  }
  var coordinates = destination;
  var tmp0 = Default_getInstance();
  // Inline function 'kotlinx.serialization.encodeToString' call
  var value = NavigationEngine_instance.w18(new LatLng(lat, lng), coordinates, minimumSegment);
  // Inline function 'kotlinx.serialization.serializer' call
  var this_4 = tmp0.ui();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_5 = serializer(this_4, createKType(getKClass(RouteProgress), arrayOf([]), false));
  var tmp$ret$9 = isInterface(this_5, KSerializer) ? this_5 : THROW_CCE();
  return tmp0.by(tmp$ret$9, value);
}
//region block: post-declaration
protoOf($serializer).mp = typeParametersSerializers;
protoOf($serializer_0).mp = typeParametersSerializers;
//endregion
//region block: init
Companion_instance = new Companion();
Companion_instance_0 = new Companion_0();
NavigationEngine_instance = new NavigationEngine();
//endregion
//region block: exports
export {
  distanceMeters as distanceMeters,
  instructionHebrew as instructionHebrew,
  routeProgressJson as routeProgressJson,
};
//endregion

//# sourceMappingURL=derech-shared.mjs.map
